module.exports = __webpack_public_path__ + "static/img/048_TO8_1571.d381046.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/048_TO8_1571.jpg
// module id = J8+Q
// module chunks = 0